/* tslint:disable */
/* eslint-disable */
/**
 * Customer Journey Endpoints
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const DocumentFeature = {
	None: 'None',
	ExpectedRegistrationDocument: 'ExpectedRegistrationDocument',
	ExpectedRegistrationDocumentInside: 'ExpectedRegistrationDocumentInside',
	ExpectedVehicle: 'ExpectedVehicle',
	ExpectedFrontLeftPerspective: 'ExpectedFrontLeftPerspective',
	ExpectedFrontRightPerspective: 'ExpectedFrontRightPerspective',
	ExpectedRearLeftPerspective: 'ExpectedRearLeftPerspective',
	ExpectedRearRightPerspective: 'ExpectedRearRightPerspective',
	ExpectedFrontPerspective: 'ExpectedFrontPerspective',
	ExpectedRearPerspective: 'ExpectedRearPerspective',
	ExpectedLeftPerspective: 'ExpectedLeftPerspective',
	ExpectedRightPerspective: 'ExpectedRightPerspective',
	ExpectedDashboardImage: 'ExpectedDashboardImage',
	MileageMustBeConsistent: 'MileageMustBeConsistent',
	ExpectedVinImage: 'ExpectedVinImage',
	ExpectedDocument: 'ExpectedDocument',
	ExpectedDamage: 'ExpectedDamage',
	ExpectedNumberPlate: 'ExpectedNumberPlate',
	ExpectedFileName: 'ExpectedFileName',
	ExpectedFileContent: 'ExpectedFileContent',
	ExpectedFileType: 'ExpectedFileType',
	FileTypeMustBeSupported: 'FileTypeMustBeSupported',
	FileNameMustHaveCorrectLength: 'FileNameMustHaveCorrectLength',
	ExpectedCorrectFileSize: 'ExpectedCorrectFileSize',
	ExpectedProcessableImage: 'ExpectedProcessableImage',
	ExpectedCertainAmountOfImages: 'ExpectedCertainAmountOfImages',
	ImageMetadataRule: 'ImageMetadataRule',
	ExpectedOverallDashboardImage: 'ExpectedOverallDashboardImage',
	ExpectedWindshieldImage: 'ExpectedWindshieldImage',
	ExpectedLimitedAmountOfAttempts: 'ExpectedLimitedAmountOfAttempts',
	NumberPlate: 'NumberPlate',
	Vin: 'Vin',
	ExpectedDiagonalPerspective: 'ExpectedDiagonalPerspective',
	AutoFilledMileage: 'AutoFilledMileage',
	PicturesSubmittedOnDifferentDevice: 'PicturesSubmittedOnDifferentDevice',
	AdditionalDamageFeature: 'AdditionalDamageFeature',
	ExpectedOdometerImage: 'ExpectedOdometerImage',
	UndesiredPhotoOfScreen: 'UndesiredPhotoOfScreen',
	MainCar: 'MainCar',
	DocumentMissingPictureRequest: 'DocumentMissingPictureRequest',
	BankFileTypeMustBeSupported: 'BankFileTypeMustBeSupported',
	ExpectedCertainAmountOfBankFiles: 'ExpectedCertainAmountOfBankFiles',
	ExpectCorrectPdfFileSize: 'ExpectCorrectPdfFileSize',
	ExpectedMileageRetake: 'ExpectedMileageRetake',
	ExpectedMileageManualInput: 'ExpectedMileageManualInput',
	ExpectedSharpImage: 'ExpectedSharpImage',
	Screenshot: 'Screenshot',
	DarkPictures: 'DarkPictures',
	LowResolution: 'LowResolution',
	BadVisibility: 'BadVisibility',
	ObstructedView: 'ObstructedView',
	CameraEffectorEdition: 'CameraEffectorEdition',
	RainSnowOrDirt: 'RainSnowOrDirt',
	InvalidPicturePerspective: 'InvalidPicturePerspective',
	CutImages: 'CutImages',
	PictreUploadLimitExceeded: 'PictreUploadLimitExceeded',
	InvalidItv: 'InvalidItv',
	InvalidPicture: 'InvalidPicture',
	WindowDown: 'WindowDown',
	InvalidVinNumber: 'InvalidVinNumber',
} as const;
export type DocumentFeature = (typeof DocumentFeature)[keyof typeof DocumentFeature];

export function instanceOfDocumentFeature(value: any): boolean {
	for (const key in DocumentFeature) {
		if (Object.prototype.hasOwnProperty.call(DocumentFeature, key)) {
			if (DocumentFeature[key as keyof typeof DocumentFeature] === value) {
				return true;
			}
		}
	}
	return false;
}

export function DocumentFeatureFromJSON(json: any): DocumentFeature {
	return DocumentFeatureFromJSONTyped(json, false);
}

export function DocumentFeatureFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): DocumentFeature {
	return json as DocumentFeature;
}

export function DocumentFeatureToJSON(value?: DocumentFeature | null): any {
	return value as any;
}

export function DocumentFeatureToJSONTyped(
	value: any,
	ignoreDiscriminator: boolean
): DocumentFeature {
	return value as DocumentFeature;
}
